import React from 'react'
import {withRouter} from 'react-router-dom'
import toast from 'react-hot-toast'

import {signInWithGoogle, sendEmailLink, mapAuthError} from '../firebase/authHelpers'
import styles from './SignIn.module.css'
import {HowToStart, WhatIsBirder, Functionalities} from '../Faq/Faq'

class SignIn extends React.Component {
  state = {
    email: '',
    sendingLink: false,
    linkSent: false,
  }

  onSignInGoogle = async () => {
    try {
      await signInWithGoogle()
      this.props.history.replace('/birdex')
    } catch (err) {
      if (
        err.code !== 'auth/popup-closed-by-user' &&
        err.code !== 'auth/cancelled-popup-request'
      ) {
        toast.error(mapAuthError(err.code))
      }
    }
  }

  onEmailChange = (e) => {
    this.setState({email: e.target.value, linkSent: false})
  }

  onSendEmailLink = async (e) => {
    e.preventDefault()
    const {email} = this.state
    if (!email) return

    this.setState({sendingLink: true})
    try {
      await sendEmailLink(email)
      this.setState({linkSent: true})
      toast.success('Kirjautumislinkki lähetetty sähköpostiisi!')
    } catch (err) {
      toast.error(mapAuthError(err.code))
    } finally {
      this.setState({sendingLink: false})
    }
  }

  render() {
    const {email, sendingLink, linkSent} = this.state

    return (
      <div className={styles.signIn}>
        <div className={styles.logo}>
          <img src="/img/icons/logo.svg" alt="Birder logo" />
        </div>
        <h1>Birder</h1>
        <p>Kirjaudu sisään</p>

        <div className={styles.loginButton} onClick={this.onSignInGoogle}>
          <span className="fab fa-google" style={{color: 'blue'}} />
          Google
        </div>

        <div className={styles.divider}>tai</div>

        <form onSubmit={this.onSendEmailLink} className={styles.emailForm}>
          <input
            type="email"
            className={styles.emailInput}
            placeholder="Sähköpostiosoite"
            value={email}
            onChange={this.onEmailChange}
            required
            disabled={sendingLink}
          />
          <button
            type="submit"
            className={styles.emailButton}
            disabled={sendingLink || !email}
          >
            {sendingLink
              ? 'Lähetetään...'
              : linkSent
              ? 'Lähetä uudelleen'
              : 'Lähetä kirjautumislinkki'}
          </button>
          {linkSent && (
            <p className={styles.linkSentNote}>
              Tarkista sähköpostisi ja klikkaa linkkiä kirjautuaksesi.
            </p>
          )}
        </form>

        <div className={styles.help}>
          <WhatIsBirder />
          <Functionalities />
          <HowToStart />
        </div>
      </div>
    )
  }
}

export default withRouter(SignIn)
